export const decodePolicyDocument = (document?: Optional<string>): string => {
  if (!document) return '';
  try {
    return decodeURIComponent(document);
  } catch {
    return document;
  }
};
